import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const Language = types.compose(
  BaseEntity,
  types.model('Language', {
    languageId: types.identifierNumber,
    alpha1: types.string,
    alpha3: types.string,
    englishName: types.string,
    nativeName: types.string,
  }),
);
